"use client";
import {
  PopoverContextProvider,
  PopoverScopedContextProvider
} from "./MWF5B7KS.js";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./72IB6YNO.js";
import {
  createStoreContext
} from "./ILRXHV7V.js";

// src/combobox/combobox-context.tsx
import { createContext } from "react";
var ComboboxListRoleContext = createContext(
  void 0
);
var ctx = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useComboboxContext = ctx.useContext;
var useComboboxScopedContext = ctx.useScopedContext;
var useComboboxProviderContext = ctx.useProviderContext;
var ComboboxContextProvider = ctx.ContextProvider;
var ComboboxScopedContextProvider = ctx.ScopedContextProvider;
var ComboboxItemValueContext = createContext(
  void 0
);
var ComboboxItemCheckedContext = createContext(false);

export {
  ComboboxListRoleContext,
  useComboboxContext,
  useComboboxScopedContext,
  useComboboxProviderContext,
  ComboboxContextProvider,
  ComboboxScopedContextProvider,
  ComboboxItemValueContext,
  ComboboxItemCheckedContext
};
